<template>
  <div>
    <div class="news-detail">
      <span @click="gotoHome" style="cursor: pointer">首页</span>
      <span>></span>
      <span style="color: #333333">航运咨询</span>
    </div>
    <div
      class="more-bottom"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.3)"
    >
      <div class="more-content">
        <div v-for="(item, index) in newsList" :key="index" class="page-news">
          <div class="news-pictrue"><img :src="item.imgPath" alt="" /></div>
          <div class="page-font">
            <div class="font-title" @click="gotoNews(item)">
              {{ item.title }}
            </div>
            <div class="content-list">
              {{ item.contentList }}
            </div>
            <div class="font-read">
              <div></div>
              <div>
                {{ item.createTime }} &nbsp;&nbsp;<i class="el-icon-view"></i>
                浏览数:{{ item.readNum }}
              </div>
            </div>
          </div>
        </div>
        <div class="page-aiton" v-if="newsList.length > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="more-right">
        <div class="more-title">
          <div class="more-line"></div>
          <div class="more-font">职位推荐</div>
        </div>
        <div
          class="more-job"
          v-for="item in jobList"
          :key="item.jobId"
          @click="gotoJob(item)"
        >
          <div class="job-title">
            <div class="job-name">{{ item.positionName }}</div>
            <!-- <div class="job-sal">
              {{ item.salaryBegin }}-{{ item.salaryEnd }}万元
            </div> -->
            <div class="job-sal" v-if="!item.mianyi">
              {{ item.salaryBegin }}-{{ item.salaryEnd }}万元
            </div>
            <div class="job-sal" v-if="item.mianyi">
              {{ item.mianyi }}
            </div>
          </div>
          <div class="job-des">
            <span>{{ item.shipTypeName }}</span>
            <span>{{ item.recuritShipTon }}吨</span>
            <span
              >{{ item.workingYearBegin }}-{{
                item.workingYearEnd
              }}年航海经验</span
            >
            <span
              >{{ item.locationProvinceName }}-{{ item.locationPortName }}</span
            >
          </div>
          <div class="job-tags">
            <p v-if="item.welfareTag.length == 0"></p>
            <div v-for="val in item.welfareTag" :key="val">{{ val }}</div>
          </div>
          <!-- <div class="job-divd"></div> -->
          <div class="job-user">
            <div>{{ item.companyName }}</div>
            <div>{{ item.refreshTime }}</div>
          </div>
        </div>
        <div class="job-line"></div>
        <div class="more-title">
          <div class="more-line"></div>
          <div class="more-font">培训推荐</div>
        </div>
        <div
          class="more-train"
          v-for="item in trainList"
          :key="item.id"
          @click="gotoTrain(item)"
        >
          <div class="train-title">{{ item.trainTitle }}</div>
          <div class="train-tags">
            <div>热门培训</div>
            <div>名额有限</div>
          </div>
          <div class="train-dec">
            <div class="train-prize">{{ item.trainPrice }}元</div>
            <div class="train-day">
              剩<span
                :style="{ color: item.planNum <= 5 ? '#ef5151' : '#2aba48' }"
                >{{ item.planNum }}</span
              >个名额
            </div>
          </div>
          <div class="job-divd"></div>
          <div class="train-user">
            <div>{{ item.companyName }}</div>
            <div>{{ item.publishTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <img :src="imgSrc" alt="" /> -->
  </div>
</template>

<script>
import {
  querySeafarerNewsList,
  queryJobsList,
  selectAlITrainplanNotePublishList,
} from "@/apis/index";
import { apiUrl } from "@/config";
export default {
  name: "HelloWorld2",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      newsDetail: {},
      imgSrc: "",
      newsList: [],
      jobList: [],
      trainList: [],
      total: 0,
      pageSize: 8,
      pageNo: 1,
      loading: true,
    };
  },
  mounted() {
    // this.newsDetail = {};
    // this.getNews();
    this.querySeafarerNews();
    this.queryJobs();
    this.selectAlITrainplanNotePublish();
  },
  created() {},
  methods: {
    async querySeafarerNews() {
      let res = await querySeafarerNewsList({
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      });
      if (res) {
        this.loading = false;
      }
      //       const timestamp = 1686713742000;
      // const date = new Date(timestamp);
      // const formattedDate = date.toISOString().slice(0, 10);
      res.resultList.forEach((item) => {
        let date = new Date(item.createTime);
        item.createTime = date.toISOString().slice(0, 10);
        // let detailData = item.content;
        // let regex = /<p[^>]*>(.*?)<\/p>/; // 使用正则表达式匹配<p>标签及其内容
        // let match = regex.exec(detailData);
        // let firstParagraphText = match[0]; // 获取匹配到的第一个<p>标签中的内容
        // let contentList = firstParagraphText.replace(/<[^>]+>/g, ""); // 获取匹配到的第一个<p>标签中的内容
        var htmlString = item.content;
        var regex = /<[^>]+>/g; // 匹配所有的HTML标签
        var contentList = htmlString.replace(regex, ""); // 移除所有HTML标签
        item.contentList = contentList;
      });
      this.total = res.rowCount;
      this.newsList = res.resultList;

      // console.log(this.newsList);
    },
    //职位
    async queryJobs() {
      const res = await queryJobsList({ pageSize: 3, pageNo: 1 });
      // console.log(res);
      res.data.resultList.forEach((item) => {
        item.welfareTag = JSON.parse(item.welfareTag);
        if (item.welfareTag.length > 3) {
          item.welfareTag = item.welfareTag.slice(0, 3);
        }
        item.refreshTime = item.refreshTime.split(" ")[0];
        item.salaryBegin = (item.salaryBegin / 10000).toFixed(2);
        item.salaryEnd = (item.salaryEnd / 10000).toFixed(2);
        if (item.salaryBegin == 0 && item.salaryEnd == 0) {
          item.mianyi = "面议";
        }
      });

      this.jobList = res.data.resultList;
    },
    //培训
    async selectAlITrainplanNotePublish() {
      const res = await selectAlITrainplanNotePublishList({
        pageSize: 3,
        pageNo: 1,
      });
      res.data.resultList.forEach((item) => {
        // item.welfareTag = JSON.parse(item.welfareTag);
        item.publishTime = item.publishTime.split(" ")[0];
      });
      this.trainList = res.data.resultList;
      // console.log(res);
    },
    //返回首页
    gotoHome() {
      this.$router.push("/home");
      // this.$forceUpdate;
    },
    // 分页
    handleSizeChange(size) {
      this.pageSize = size;
      // 调用后台接口或重新获取数据
      // this.selectRecordList();
      this.querySeafarerNews();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 调用后台接口或重新获取数据
      // this.selectRecordList();
      this.querySeafarerNews();
    },
    //新闻详情
    gotoNews(item) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$router.push({ name: "crewNewsDetail", params: { id: item.id } });
      this.getNews();
    },
    navigateTo(url) {
      // 创建 XMLHttpRequest 对象
      var xhr = new XMLHttpRequest();

      // 监听请求状态变化
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            // 请求成功，执行页面跳转
            window.location.href = url;
          } else {
            // 请求失败，执行错误处理逻辑
            console.error("请求失败");
          }
        }
      };

      // 发送 GET 请求
      xhr.open("GET", url, true);
      xhr.send();
    },
    //招聘
    gotoJob(item) {
      if (
        sessionStorage.getItem("tolog") &&
        (sessionStorage.getItem("userType") == 0 ||
          sessionStorage.getItem("userType") == 5 ||
          sessionStorage.getItem("userType") == 4)
      ) {
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/postDetail/${
          item.jobId
        }/?tolog=${sessionStorage.getItem("tolog")}`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/postDetail/${item.jobId}/?homeTitle=true`;
      }
    },
    //培训
    gotoTrain(item) {
      if (
        (sessionStorage.getItem("tolog") &&
          sessionStorage.getItem("userType") == 0) ||
        sessionStorage.getItem("userType") == 4 ||
        (sessionStorage.getItem("userType") == 1 &&
          sessionStorage.getItem("isLand") == 0)
      ) {
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${
          item.id
        }/0?tolog=${sessionStorage.getItem("tolog")}`;
        // window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${item.id}/0?homeTitle=true`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${item.id}/0?homeTitle=true`;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
